import { offerPlacementSelectionSchema } from "@redotech/redo-integrations-definitions-common/offer-network/offer-placement";
import * as z from "zod";

// null clears the selection (disables the order status block).
export const setOrderStatusOfferPlacement = {
  name: "setOrderStatusOfferPlacement" as const,
  input: z.object({ selection: offerPlacementSelectionSchema.nullable() }),
  output: z.object({ success: z.boolean() }),
};
